<div>
  <slot />
</div>

<style lang="scss">
  div {
    text-align: right;
  }
</style>
